import cliveLoadingAnimation from '~/assets/animations/clive-loading.json';
import cliveNeutralAnimation from '~/assets/animations/clive-neutral.json';
import cliveSadAnimation from '~/assets/animations/clive-sad.json';

// Lottie animation data kept out of cliveRegistry so the widely-imported
// registry doesn't pull ~60KB of animation JSON into every consumer's chunk.
export const CLIVE_LOTTIE_ANIMATIONS = {
  neutral: cliveNeutralAnimation,
  loading: cliveLoadingAnimation,
  sad: cliveSadAnimation,
} as const;
